export function getInfos() {
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("email");
  const role = localStorage.getItem("role");
  const name = localStorage.getItem("name");
  const cpf = localStorage.getItem("cpf");

  if (!token || !email || !role || !name || !cpf) return null;
  return {
    token,
    email,
    role,
    name,
    cpf,
  };
}

export function getUserRole() {
  const user = getInfos();
  if (!user) return null;

  return user.role;
}

export function isAdmin() {
  return getUserRole() === "admin";
}
